import { useState } from "react";
import { FiTarget, FiPlusCircle } from "react-icons/fi";
import AppLayout from "../components/common/AppLayout";
import MetaCard from "../components/metas/MetaCard";
import MetaForm from "../components/metas/MetaForm";
import AporteForm from "../components/metas/AporteForm";
import AportesMetaModal from "../components/metas/AportesMetaModal";
import useMetas from "../hooks/useMetas";

export default function MetasPage() {
    const {
        metas,
        loading,
        guardar,
        aportar,
        aportes,
        loadingAportes,
        cargarAportes,
    } = useMetas();

    const [openMeta, setOpenMeta] = useState(false);
    const [openAporte, setOpenAporte] = useState(false);
    const [openHistorial, setOpenHistorial] = useState(false);

    const [editing, setEditing] = useState(null);
    const [selectedMeta, setSelectedMeta] = useState(null);

    return (
        <AppLayout
            title={
                <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                    <FiTarget size={30} />
                    Metas de ahorro
                </span>
            }
        >
            <div className="toolbar-row">
                <button
                    className="btn-primary"
                    type="button"
                    onClick={() => {
                        setEditing(null);
                        setOpenMeta(true);
                    }}
                >
                    <FiPlusCircle size={18} />
                    Nueva meta
                </button>
            </div>

            {loading ? (
                <p>Cargando...</p>
            ) : (
                <div className="cuentas-grid">
                    {metas.map((meta) => (
                        <MetaCard
                            key={meta.idMeta}
                            meta={meta}
                            onEdit={(row) => {
                                setEditing(row);
                                setOpenMeta(true);
                            }}
                            onAportar={(row) => {
                                setSelectedMeta(row);
                                setOpenAporte(true);
                            }}
                            onVerHistorial={async (row) => {
                                setSelectedMeta(row);
                                await cargarAportes(row.idMeta);
                                setOpenHistorial(true);
                            }}
                        />
                    ))}
                </div>
            )}

            {openMeta && (
                <MetaForm
                    initialData={editing}
                    onClose={() => setOpenMeta(false)}
                    onSave={async (payload) => {
                        await guardar(payload, editing?.idMeta);
                        setOpenMeta(false);
                    }}
                />
            )}

            {openAporte && selectedMeta && (
                <AporteForm
                    meta={selectedMeta}
                    onClose={() => setOpenAporte(false)}
                    onSave={async (payload) => {
                        await aportar(selectedMeta.idMeta, payload);
                        setOpenAporte(false);
                    }}
                />
            )}

            {openHistorial && selectedMeta && (
                <AportesMetaModal
                    meta={selectedMeta}
                    aportes={aportes}
                    loading={loadingAportes}
                    onClose={() => setOpenHistorial(false)}
                />
            )}
        </AppLayout>
    );
}